import './App.css';
import { useState, useEffect, useRef } from "react";

export default function App() {
  const [text, setText] = useState("Loading...");
  const textRef = useRef(null);

  const fetchRandomText = async () => {
    try {
      //const res = await fetch("http://localhost:5500/api/random-text");
      const res = await fetch("/api/random-text");
      const data = await res.json();
      setText(data.text);
    } catch (err) {
      console.error("Error fetching text:", err);
      setText("Failed to load text. Try again.");
    }
  };

  useEffect(() => {
    fetchRandomText();
  }, []);

  // Adjust font size based on container height
  useEffect(() => {
    const adjustFontSize = () => {
      const container = textRef.current;
      if (!container) return;

      let fontSize = 100; // start large
      container.style.fontSize = fontSize + "px";

      const containerHeight = container.parentElement.clientHeight * 0.9; // leave some padding
      while (container.scrollHeight > containerHeight && fontSize > 10) {
        fontSize -= 1;
        container.style.fontSize = fontSize + "px";
      }
    };

    adjustFontSize();
    window.addEventListener("resize", adjustFontSize);
    return () => window.removeEventListener("resize", adjustFontSize);
  }, [text]);

  return (
    <div className="container">
      <div className="text-box" ref={textRef}>{text}</div>
      <div className="footer-text">NCHS Cyber</div>
    </div>
  );
}
